export default __webpack_public_path__ + "static/media/flixxo-primary.f67cf009.svg";